import $ from 'cash-dom';

// TODO
// reset after close

const openMenu = () => {
  const $menuOpener = $('.js-menu-opener');
  const $menu = $('.js-menu');
  const $activeMenu = $('.js-menu').find('.menu.is-active');
  const $list = $activeMenu.find('.menu-list__item');
  const $listName = $activeMenu.find('.menu__name');
  const $headerLine = $('.header__line');

  $menuOpener.on('click', () => {
    if ($menuOpener.hasClass('is-active')) {
      // reset default setting
      $menuOpener.removeClass('is-active');
      $menu.addClass('is-fade-out');
      $headerLine.removeClass('to-transform').addClass('to-opacity');
      setTimeout(() => {
        $menu.removeClass('is-active is-visible is-product-active is-fade-out');
        $menu.find('a, div, img, p, span').removeClass('is-active is-visible is-product-active is-fade-out is-fade-in');
        $('#main-menu').addClass('is-active');
      }, 400);

      $listName.removeClass('is-fade-in');
      $list.removeClass('is-fade-in');
    } else {
      $menuOpener.addClass('is-active');
      $menu.addClass('is-active is-visible');

      setTimeout(() => {
        $listName.addClass('is-fade-in');
      }, 370);

      $list.each((i, el) => {
        const $thisItem = $(el);
        setTimeout(() => {
          $thisItem.addClass('is-fade-in');
        }, i * 50 + 420);
      });
    }
  });
};

const changeHeaderMenu = () => {
  const $link = $('.js-change-menu');
  const $menu = $('.js-menu');
  const $headerLine = $('.header__line');

  $link.on('click', (e) => {
    e.preventDefault();
    let lastTimeOut = 0;
    let lastTimeOut2 = 250;

    const $this = $(e.currentTarget);
    const $parentMenu = $this.parents('.menu.is-active');
    const nextMenuID = $this.attr('href');
    const $nextMenu = $(nextMenuID);

    const $listPrev = $parentMenu.find('.menu-list__item');
    const $listNamePrev = $parentMenu.find('.menu__name');
    const $listNext = $nextMenu.find('.menu-list__item');
    const $listNameNext = $nextMenu.find('.menu__name');

    // fade out previous items
    $listNamePrev.addClass('is-fade-out');
    $listPrev.each((i, el) => {
      const $thisItem = $(el);
      lastTimeOut += 100;

      setTimeout(() => {
        $thisItem.addClass('is-fade-out');
      }, lastTimeOut);
    });

    // clearing
    setTimeout(() => {
      $parentMenu.removeClass('is-active');
      $listPrev.removeClass('is-fade-out is-fade-in');
      $listNamePrev.removeClass('is-fade-out is-fade-in');
      $nextMenu.addClass('is-active');
    }, lastTimeOut);

    // fade in next items
    $listNameNext.addClass('is-fade-in');
    $listNext.each((i, el) => {
      const $thisItem = $(el);
      lastTimeOut += 100;

      setTimeout(() => {
        $thisItem.addClass('is-fade-in');
      }, lastTimeOut);
    });

    // if another submenu
    if ($nextMenu.hasClass('js-menu-products')) {
      const productName = $this.data('product');
      const $menuLinks = $nextMenu.find('.menu-list__link');
      const $productWrap = $('.product');
      let $linkToShow = $($menuLinks[0]);
      let productID = $linkToShow.attr('href');
      let $product = $(productID);
      let $productChildren = $product.children();
      const $lines = $('.product-lines');

      if (productName !== undefined) {
        $menuLinks.each((i, el) => {
          const $currentEl = $(el);
          const currentHref = $currentEl.attr('href');

          if (currentHref.indexOf(productName) >= 0) {
            $linkToShow = $currentEl;
            productID = $linkToShow.attr('href');
            $product = $(productID);
            $productChildren = $product.children();
          }
        });
      }

      if (!$productWrap.hasClass('is-active')) {
        $headerLine.addClass('to-transform').removeClass('to-opacity');
        $productWrap.addClass('is-active');
        $menu.addClass('is-product-active');
      }

      $menuLinks.removeClass('is-active');
      $linkToShow.addClass('is-active');

      $('.product__item').removeClass('is-active');
      $product.addClass('is-active');

      $productChildren.each((i, el) => {
        const $thisItem = $(el);
        lastTimeOut2 += 100;

        setTimeout(() => {
          $thisItem.addClass('is-fade-in');
          $headerLine.removeClass('to-transform').addClass('to-opacity');
        }, lastTimeOut2);
      });

      setTimeout(() => {
        $lines.addClass('is-fade-in');
      }, lastTimeOut2);
    } else {
      const $productWrap = $('.product');

      if ($productWrap.hasClass('is-active')) {
        $productWrap.removeClass('is-active');
        $menu.removeClass('is-product-active');
      }
    }
  });
};

const changeProduct = () => {
  const $productLinks = $('.js-change-product');
  let timePlusAnimationTime = 0;

  const activeItem = (e) => {
    let lastTimeOut = 0;
    const $nextLink = $(e);
    const productID = $nextLink.attr('href');
    const $next = $(productID);
    const $nextChildren = $next.children();
    const $prev = $('.product__item.is-active');
    const $prevChildren = $('.product__item.is-active').children();
    const date = new Date();
    const currentTime = date.getTime();

    if (timePlusAnimationTime <= currentTime) {
      timePlusAnimationTime = 0;
    }

    if ($next.length
      && !$next.hasClass('is-active')
      && (timePlusAnimationTime <= currentTime)) {
      $('.js-change-product').removeClass('is-active');
      $nextLink.addClass('is-active');

      $prevChildren.each((i, el) => {
        const $thisItem = $(el);

        if (!$thisItem.hasClass('product__link')) {
          lastTimeOut += 100;

          setTimeout(() => {
            $thisItem.addClass('is-fade-out');
          }, lastTimeOut);
        }
      });
      lastTimeOut += 150; // to end last anim
      setTimeout(() => {
        $prev.removeClass('is-active');
        $nextChildren.removeClass('is-fade-out is-fade-in');
        $prevChildren.removeClass('is-fade-out is-fade-in');
        $next.addClass('is-active');
      }, lastTimeOut);

      $nextChildren.each((i, el) => {
        const $thisItem = $(el);

        if (!$thisItem.hasClass('product__link')) {
          lastTimeOut += 100;

          setTimeout(() => {
            $thisItem.addClass('is-fade-in');
          }, lastTimeOut);
        }
      });

      timePlusAnimationTime += currentTime + lastTimeOut + 150; // 150 to end of last animation
    }
  };

  $productLinks
    .on('mouseover', (e) => {
      if ($(window).width() >= 900) {
        activeItem(e.currentTarget);
      }
    })
    .on('mousemove', (e) => {
      if ($(window).width() >= 900) {
        activeItem(e.currentTarget);
      }
    })
    .on('click', (e) => {
      if ($(window).width() < 900) {
        activeItem(e.currentTarget);
      } else {
        window.location.href = $(e.currentTarget).data('link');
      }
    });
};

export {
  changeHeaderMenu,
  changeProduct,
  openMenu,
};
